import "./info-modal.scss";

const InfoModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="info-overlay" onClick={onClose}>
            <div className="info-modal" onClick={(e) => e.stopPropagation()}>
                <div className="info-modal-header">
                    <h2>How to Play</h2>
                    <button className="close-btn" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="info-modal-body">
                    <div className="info-section">
                        <h3>The Game</h3>
                        <p>
                            Flip A Coin is a daily streak challenge. Each day you
                            get one coin flip. The coin lands on heads or tails
                            randomly.
                        </p>
                    </div>
                    <div className="info-section">
                        <h3>Streaks</h3>
                        <p>
                            If the coin lands on the same side as your previous
                            flip, your streak grows by one. If it lands on the
                            opposite side, your streak resets to 1.
                        </p>
                    </div>
                    <div className="info-section">
                        <h3>Leaderboard</h3>
                        <p>
                            Your best streak is saved and ranked against all
                            other players. Sign in to compete on the global
                            leaderboard.
                        </p>
                    </div>
                    <div className="info-section">
                        <h3>Guest Mode</h3>
                        <p>
                            You can flip as many times as you want without
                            signing in. Your streak is saved locally in your
                            browser. Sign in to save it to the leaderboard.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoModal;
